module.exports = __webpack_public_path__ + "static/media/iflares_Logo_LUZ.d06948f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/complex/cleanlocal/images/iflares_Logo_LUZ.png
// module id = 2184
// module chunks = 1